import { render, staticRenderFns } from "./ModalConfirmarAssinarDocumento.vue?vue&type=template&id=58db228f&scoped=true"
import script from "./ModalConfirmarAssinarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarAssinarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarAssinarDocumento.vue?vue&type=style&index=0&id=58db228f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db228f",
  null
  
)

export default component.exports